import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { IconMenu2, IconGridDots } from '@tabler/icons';
import colors from '../../util/colors.js';
import Avatar from '../Avatar/Avatar.component.js';
import { ReactComponent as SvgAccount } from '../Icon/icons/account.svg.js';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import { propTypes, defaultProps } from './LeftNavHeader.types.js';
import styles from './LeftNavHeader.module.scss.js';

/**
 * Show the application header bar.
 *
 * This bar spans across the page and displays basic information to the user:
 *   - The current applications name
 *   - The current page name
 *   - The name of the current merchant
 *   - The address of the current merchant
 *   - Button to toggle the main menu
 *   - Button to toggle the settings
 *
 * This header bar is fully responsive.
 */
var LeftNavHeader = /** @class */ (function (_super) {
    __extends(LeftNavHeader, _super);
    function LeftNavHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderUserDetails = function () {
            var _a = _this.props, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, userName = _a.userName, userAddress = _a.userAddress, userInfo = _a.userInfo, classNames = _a.classNames;
            if (isLoading) {
                return (React__default.createElement("div", { className: clsx(styles.UserDetails, classNames === null || classNames === void 0 ? void 0 : classNames.UserDetails) },
                    React__default.createElement("div", { className: styles.LoadingPlaceholder }),
                    React__default.createElement("div", { className: styles.LoadingPlaceholder + " " + styles.LoadingPlaceholder___small })));
            }
            return (React__default.createElement("div", { className: clsx(styles.UserDetails, classNames === null || classNames === void 0 ? void 0 : classNames.UserDetails) },
                React__default.createElement("p", { className: styles.UserDetails_name }, userName),
                React__default.createElement("p", { className: styles.UserDetails_address }, userInfo || userAddress)));
        };
        _this.renderAvatarIcon = function () {
            // A temporary solution to reduce the bundle,
            // after fixing the Icon component,
            // uncomment Icon and remove inline svg
            // return (
            //     <Icon
            //         name="AccountIcon"
            //         alt="account"
            //         size={24}
            //         className={styles.Mobile}
            //     />
            // );
            return React__default.createElement(SvgAccount, { width: 24, height: 24, className: styles.Mobile });
        };
        _this.renderAvatarButton = function () {
            var _a = _this.props, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, photoUrl = _a.photoUrl, userNameInitials = _a.userNameInitials, avatarColor = _a.avatarColor, toggleSettingsMenu = _a.toggleSettingsMenu, classNames = _a.classNames;
            if (isLoading) {
                return (React__default.createElement("button", { className: styles.AvatarButton, onClick: toggleSettingsMenu },
                    React__default.createElement("div", { className: clsx(styles.AvatarLoading, styles.TabletAndUp) }),
                    _this.renderAvatarIcon()));
            }
            return (React__default.createElement("button", { className: styles.AvatarButton, onClick: toggleSettingsMenu },
                React__default.createElement(Avatar, { photoUrl: photoUrl, initials: userNameInitials, className: clsx(styles.TabletAndUp, classNames === null || classNames === void 0 ? void 0 : classNames.UserDetailsAvatar), avatarColor: avatarColor }),
                _this.renderAvatarIcon()));
        };
        return _this;
    }
    LeftNavHeader.prototype.render = function () {
        var _a = this.props, className = _a.className, classNames = _a.classNames, applicationName = _a.applicationName, currentPageName = _a.currentPageName, primaryAction = _a.primaryAction, secondaryActions = _a.secondaryActions, toggleMainMenu = _a.toggleMainMenu, toggleVerticalsMenu = _a.toggleVerticalsMenu;
        return (React__default.createElement("header", { className: clsx(styles.LeftNavHeader, primaryAction
                ? styles.LeftNavHeader___withCenteredContent
                : '', className, classNames === null || classNames === void 0 ? void 0 : classNames.LeftNavHeader) },
            React__default.createElement("div", { className: styles.LeftNavHeader_action },
                React__default.createElement(ButtonBase, { className: clsx(styles.Mobile, styles.Tablet, styles.Button), type: "button", onClick: toggleMainMenu, title: "Open app menu", color: colors.black },
                    React__default.createElement(IconMenu2, { color: colors.black, stroke: 1.5 })),
                React__default.createElement(ButtonBase, { className: clsx(styles.Desktop, styles.Button), type: "button", onClick: toggleVerticalsMenu, title: "Open verticals menu" },
                    React__default.createElement(IconGridDots, { color: colors.primary90 }))),
            React__default.createElement("div", { className: styles.LeftNavHeader_content },
                React__default.createElement("div", { className: styles.LeftNavHeaderTitle },
                    React__default.createElement("span", { className: styles.LeftNavHeaderTitle_text }, applicationName)),
                React__default.createElement("div", { className: styles.LeftNavHeaderPage },
                    React__default.createElement("span", { className: styles.LeftNavHeaderPage_text }, currentPageName)),
                primaryAction,
                React__default.createElement("div", { className: styles.LeftNavHeaderContent },
                    secondaryActions,
                    React__default.createElement("div", { className: clsx(styles.LeftNavHeaderUserDetails, classNames === null || classNames === void 0 ? void 0 : classNames.LeftNavHeaderUserDetails) },
                        React__default.createElement("div", { className: styles.LeftNavHeaderUserDetails_details }, this.renderUserDetails()),
                        this.renderAvatarButton())))));
    };
    LeftNavHeader.displayName = 'LeftNavHeader';
    LeftNavHeader.propTypes = propTypes;
    LeftNavHeader.defaultProps = __assign({}, defaultProps);
    return LeftNavHeader;
}(React__default.Component));

export { LeftNavHeader as default };
